import { useState, useEffect } from 'react';

/**
 * Custom hook for AEO (Answer Engine Optimization) metrics
 * Tracks AI-driven search performance and citations
 */
export const useAEO = (dateRange) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    setError(null);

    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 800));

      // Mock data for AEO metrics
      const mockData = {
        metrics: {
          referralTraffic: 4850,
          aeoImpressions: 125000,
          citationFrequency: 342,
          aiEngineVisibility: 78.5,
          averagePosition: 2.3,
          clickThroughRate: 3.88,
        },
        changes: {
          referralTraffic: 18.5,
          aeoImpressions: 24.2,
          citationFrequency: 12.7,
          aiEngineVisibility: 8.3,
          averagePosition: -15.2, // Negative is good (lower position number)
          clickThroughRate: 22.1,
        },
        aiEngines: [
          {
            name: 'ChatGPT',
            citations: 128,
            referrals: 1850,
            impressions: 45000,
          },
          {
            name: 'Perplexity',
            citations: 94,
            referrals: 1420,
            impressions: 32000,
          },
          {
            name: 'Google SGE',
            citations: 76,
            referrals: 980,
            impressions: 28000,
          },
          {
            name: 'Bing Copilot',
            citations: 44,
            referrals: 600,
            impressions: 20000,
          },
        ],
      };

      setData(mockData);
    } catch (err) {
      setError(err.message || 'Failed to fetch AEO data');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const refetch = () => fetchData(true);

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
};